export const DRAWER_WIDTH = 200;
export const APP_URL = "https://app.quickcomp.io";
